import React from 'react';
import { ConfigProvider, Tag } from 'antd';
import { useTheme } from '../../theme/ThemeContext';

export interface HighlightBadgeProps {
    value: string | number;
    type?: 'positive' | 'negative' | 'neutral';
    'data-test'?: string;
    'data-test-id'?: string;
}

const HighlightBadge: React.FC<HighlightBadgeProps> = (props) => {
    const { value, type = 'neutral' } = props;
    const theme = useTheme();

    const getColor = () => {
        switch (type) {
            case 'positive':
                return '#389E0D'; // Darker green - more readable
            case 'negative':
                return '#FF4D4F'; // Red
            default:
                return '#1890FF'; // Blue
        }
    };

    return (
        <ConfigProvider theme={theme}>
            <Tag
                style={{
                    color: getColor(),
                    backgroundColor: 'transparent',
                    border: 'none',
                    fontSize: '14px',
                    lineHeight: '22px',
                    padding: '0 4px',
                    margin: '0 2px',
                    display: 'inline-block',
                    fontFamily: "'Open Sans', sans-serif",
                    fontWeight: 'bold',
                }}
                data-test={props['data-test']}
                data-test-id={props['data-test-id']}
                data-asper-highlight-badge
            >
                {value}
            </Tag>
        </ConfigProvider>
    );
};

export default HighlightBadge;
